import React from "react";
import { Modal, Button } from "react-bootstrap";

const LogoutModal = ({ show, onHide, onConfirm, setCurrentTab }) => {
    const handleCancel = () => {
        setCurrentTab("home");
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>אישור התנתקות</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                האם אתה בטוח שברצונך להתנתק מהמערכת?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    ביטול
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    התנתק
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LogoutModal; 